
import { FormProps } from '../form-components/types';

type ValueSetterPair = {
  value: any;
  setter: (value: any) => void;
} | null;

export const getValueAndSetter = (fieldName: string, formProps: FormProps): ValueSetterPair => {
  console.log(`Getting value/setter for field: ${fieldName}`);
  
  // Map field names to their corresponding values and setters in formProps
  const mappings: Record<string, { value: any; setter: (value: any) => void }> = {
    // Standard mappings
    'customerName': { value: formProps.customerName, setter: formProps.setCustomerName },
    'customerPhone': { value: formProps.customerPhone, setter: formProps.setCustomerPhone },
    'customerEmail': { value: formProps.customerEmail, setter: formProps.setCustomerEmail },
    'customerAddress': { value: formProps.customerAddress, setter: formProps.setCustomerAddress },
    'customerRegion': { value: formProps.customerRegion, setter: formProps.setCustomerRegion },
    'customerMunicipality': { value: formProps.customerMunicipality, setter: formProps.setCustomerMunicipality },
    'note': { value: formProps.note, setter: formProps.setNote },
    'quantity': { value: formProps.quantity?.toString(), setter: (value) => {
      const parsedValue = parseInt(value);
      if (!isNaN(parsedValue)) {
        formProps.setQuantity(parsedValue);
      }
    }},
    
    // Alternative names for the same fields
    'nom': { value: formProps.customerName, setter: formProps.setCustomerName },
    'telephone': { value: formProps.customerPhone, setter: formProps.setCustomerPhone },
    'téléphone': { value: formProps.customerPhone, setter: formProps.setCustomerPhone },
    'phone': { value: formProps.customerPhone, setter: formProps.setCustomerPhone },
    'email': { value: formProps.customerEmail, setter: formProps.setCustomerEmail },
    'adresse': { value: formProps.customerAddress, setter: formProps.setCustomerAddress },
    'address': { value: formProps.customerAddress, setter: formProps.setCustomerAddress },
    'région': { value: formProps.customerRegion, setter: formProps.setCustomerRegion },
    'region': { value: formProps.customerRegion, setter: formProps.setCustomerRegion },
    'wilaya': { value: formProps.customerRegion, setter: formProps.setCustomerRegion },
    'municipalité': { value: formProps.customerMunicipality, setter: formProps.setCustomerMunicipality },
    'municipality': { value: formProps.customerMunicipality, setter: formProps.setCustomerMunicipality },
    'commune': { value: formProps.customerMunicipality, setter: formProps.setCustomerMunicipality },
    'notes': { value: formProps.note, setter: formProps.setNote },
    'quantité': { value: formProps.quantity?.toString(), setter: (value) => {
      const parsedValue = parseInt(value);
      if (!isNaN(parsedValue)) {
        formProps.setQuantity(parsedValue);
      }
    }},
  };

  // Handle case-insensitive matching and normalize field names
  const normalizedFieldName = fieldName.toLowerCase().trim();
  
  for (const [key, pair] of Object.entries(mappings)) {
    if (key.toLowerCase() === normalizedFieldName) {
      console.log(`Found match for field ${fieldName}: value = ${pair.value}`);
      return pair;
    }
  }

  console.warn(`No value-setter pair found for field name: ${fieldName}`);
  return null;
};
